/** Traductions tableau de bord manager (FR / AR) — libellés courts et clairs */
export const managerDashboardFr = {
  skipToContent: 'Aller au contenu principal',
  userLabel: 'Utilisateur: {{name}}',
  manager: 'Manager',
  periodLabel: 'Période :',
  selectPeriodAria: 'Sélectionner la période',
  changePeriodTitle: 'Changer la période du rapport',
  periodToday: "Aujourd'hui",
  period7Days: '7 jours',
  period30Days: '30 jours',
  period90Days: '90 jours',
  periodCustom: 'Date précise',
  customDateLabel: 'Date',
  customDatePlaceholder: 'Choisir une date',
  customDateAria: 'Choisir une date précise',
  ariaOpenSalesReport: 'Ouvrir le rapport des ventes',
  ariaOpenMethodReport: 'Ouvrir le rapport pour {{method}}',
  ariaOpenMethodSalesReport: 'Ouvrir les ventes {{method}}',
  moneyIn: 'Ventes',
  fromSales: 'Chiffre d\'affaires',
  transactions: 'ventes',
  ariaOpenOutflowReport: 'Ouvrir le rapport des sorties',
  moneyOut: 'Sorties',
  moneyOutBoth: 'Fournisseurs {{payments}} • Charges {{expenses}}',
  moneyOutPaymentsOnly: 'Fournisseurs {{amount}}',
  moneyOutExpensesOnly: 'Charges {{amount}}',
  moneyOutEmpty: 'Aucune sortie sur la période',
  supplierPaymentsOut: 'Fournisseurs',
  operatingExpensesOut: 'Charges',
  paymentsAndExpenses: 'Fournisseurs + charges',
  ariaOpenBalanceReport: 'Ouvrir le rapport solde',
  treasuryBalance: 'Solde total',
  treasuryBalancePeriodHint: 'Sur la période sélectionnée (pas le bilan complet)',
  inOutMeta: 'Liquidité par moyen de paiement',
  electronicTotal: 'Électronique',
  balanceStateTitle: 'État des soldes',
  balanceMethodColShort: 'Moyen',
  balanceInCol: 'Entrées',
  balanceInColShort: 'Entrées',
  balancePaymentsOutCol: 'Paiements fournisseurs',
  balancePaymentsOutColShort: 'Fournisseurs',
  balanceExpensesOutCol: 'Dépenses (charges)',
  balanceExpensesOutColShort: 'Charges',
  balanceOutCol: 'Sorties caisse',
  balanceOutColShort: 'Sorties',
  balanceSoldeCol: 'Solde',
  balanceSoldeColShort: 'Solde',
  balanceFinancingCol: 'Financement externe',
  balanceFinancingColShort: 'Externe',
  balanceOpeningCapitalCol: 'Capital démarrage',
  balanceOpeningCapitalColShort: 'Capital',
  balanceFinancingHint:
    'Capital démarrage ≠ Financement externe. Ni l\'un ni l\'autre n\'entre dans le solde. Externe n\'est pas limité aux espèces.',
  noBalanceMethods: 'Aucun mouvement sur la période',
  weeklySalesAria: 'Ventes sur 7 jours',
  revenueEvolution7Days: 'Ventes (7 jours)',
  todayRevenueTitle: 'Ventes du jour',
  urgentAlerts: 'Alerte',
  ariaOpenEcarts: 'Ouvrir les écarts de caisse',
  openEcarts: 'Écarts caisse',
  ecartsChartAlert: '{{count}} écart(s) à valider',
  urgentAlertTitleOne: 'Écart détecté',
  urgentAlertTitleMany: 'Écarts détectés',
  ecartsNeedReviewOne: 'Un écart de caisse doit être vérifié.',
  ecartsNeedReviewMany: '{{count}} écarts de caisse à vérifier.',
  openEcartsSummary: 'Détail des écarts',
  positive: 'Surplus',
  negative: 'Manque',
  ecartCount: 'cas',
  total: 'Total',
  excess: 'Surplus',
  shortage: 'Manque',
  totalLabel: 'total',
  ecartTotalMeta: '{{type}} • {{count}} cas',
  paymentMethods: 'Paiements',
  indicator: 'Ligne',
  amount: 'Montant',
  transactionsHeader: 'Nombre',
  amountRow: 'Montant',
  countRow: 'Nb',
  periodCol: 'Période',
  moneyInCol: 'Ventes',
  paymentsCol: 'Fournisseurs',
  expensesCol: 'Charges',
  balanceCol: 'Solde',
  noPaymentMethods: 'Aucun paiement enregistré',
  dailyWeeklyReports: 'Récap période',
  period: 'Période',
  moneyInTable: 'Ventes',
  payments: 'Fournisseurs',
  expenses: 'Charges',
  balance: 'Solde',
  ariaOpenTodayReport: 'Ouvrir le rapport du jour',
  today: 'Jour',
  ariaOpenWeekReport: 'Ouvrir le rapport de la semaine',
  sevenDays: 'Semaine',
  financialSummaryTitle: 'Résumé financier',
  moneyInCard: 'Ventes',
  netFlow: 'Solde total',
  inOutSubtitle: 'Tous moyens — entrées − sorties caisse',
  paymentsExpensesCard: 'Sorties totales',
  paymentsExpensesSubtitle: 'Fourn. {{payments}} | Charges {{expenses}}',
  quickActions: 'Actions',
  keyboardHints: 'Raccourcis : 1–7 actions, R rapport, E écarts',
  quickActionsAria: 'Actions rapides',
  backToDashboard: 'Tableau de bord',
  backToDashboardAria: 'Retour au tableau de bord',
  familyEyebrow: 'Depuis le tableau de bord',
  shortcutN: 'Raccourci {{n}}',
  shortcut3OrR: 'Raccourci 3 ou R',
  shortcut5OrR: 'Raccourci 5 ou R',
  scopePeriod: 'Période',
  scopeToday: 'Jour',
  scopeCurrent: 'Actuel',
  scopeMixed: 'Période · actuel',
  railMoneyGroup: 'Sorties et obligations',
  railStockGroup: 'Risque stock',
  railStockOk: 'Aucun signal stock',
  showFinancingCols: 'Capital / externe',
  hideFinancingCols: 'Masquer détail',
  sales: 'Ventes',
  moneyOutAction: 'Sorties',
  paymentReport: 'Paiements',
  ecarts: 'Écarts',
  inventory: 'Produits',
  reports: 'Rapports',
  sessions: 'Sessions',
  ariaOpenSessions: 'Ouvrir les sessions dans Paramètres',
  dayClosing: 'Clôture jour',
  ariaOpenDayClosing: 'Ouvrir la clôture du jour dans Rapports',
  lotMigration: 'Migration lots',
  needsImmediateReview: 'À contrôler',
  kpiSalesFoot: '{{count}} ventes',
  kpiBalanceFoot: 'Détail par moyen ci-dessous',
  kpiExternalFinancingFoot: 'Financement externe : {{amount}}',
  externalFinancingSummary: 'Financement externe (hors caisse)',
  openingCapitalFinancingSummary: 'Capital démarrage utilisé',
  kpiAvgTicket: 'Ticket moyen',
  kpiVsPrevious: 'vs période préc.',
  kpiUpdatedAt: 'MAJ {{time}}',
  kpiExpenses: 'Charges',
  kpiChangeFlat: '0 %',
  chartVsPreviousPeriod: 'vs période précédente',
  chartMetricRevenue: 'Chiffre d\'affaires',
  chartMetricProfit: 'Marge',
  chartMetricSales: 'Ventes',
  chartMetricCustomers: 'Clients',
  inventoryCardTitle: 'Produits',
  inventoryProducts: '{{count}} produits',
  inventoryCritical: '{{count}} critiques',
  inventoryExpiring: '{{count}} expirent bientôt',
  inventoryEmptyLots: '{{count}} lots vides',
  inventoryActiveLots: '{{count}} lots actifs',
  finOpenSupplierInvoices: 'Factures fourn. ouvertes (nous devons)',
  finInventoryValue: 'Valeur stock',
  finLowStock: 'Stock faible',
  finOrderToday: "À commander aujourd'hui",
  finExpiring: 'Produits à date',
  finActiveLots: 'Lots actifs',
  topActionSale: 'Vente',
  topActionPurchase: 'Achat',
  topActionProduct: 'Produit',
  topActionCustomer: 'Client',
  topActionSupplier: 'Fournisseur',
  topQuickActionsAria: 'Création rapide',
  ariaOpenInventory: 'Ouvrir Produits',
  loadingData: 'Chargement des données…',
};

export const managerDashboardAr = {
  skipToContent: 'الانتقال إلى المحتوى الرئيسي',
  userLabel: 'المستخدم: {{name}}',
  manager: 'مدير',
  periodLabel: 'الفترة:',
  selectPeriodAria: 'اختر الفترة',
  changePeriodTitle: 'تغيير فترة التقرير',
  periodToday: 'اليوم',
  period7Days: '7 أيام',
  period30Days: '30 يوم',
  period90Days: '90 يوم',
  periodCustom: 'تاريخ محدد',
  customDateLabel: 'التاريخ',
  customDatePlaceholder: 'اختر تاريخاً',
  customDateAria: 'اختر تاريخاً محدداً',
  ariaOpenSalesReport: 'فتح تقرير المبيعات',
  ariaOpenMethodReport: 'فتح التقرير لـ {{method}}',
  ariaOpenMethodSalesReport: 'فتح مبيعات {{method}}',
  moneyIn: 'مبيعات',
  fromSales: 'إيرادات',
  transactions: 'عملية',
  ariaOpenOutflowReport: 'فتح تقرير المصروفات',
  moneyOut: 'مصروفات',
  moneyOutBoth: 'موردين {{payments}} • مصاريف {{expenses}}',
  moneyOutPaymentsOnly: 'موردين {{amount}}',
  moneyOutExpensesOnly: 'مصاريف {{amount}}',
  moneyOutEmpty: 'لا مصروفات في هذه الفترة',
  supplierPaymentsOut: 'الموردين',
  operatingExpensesOut: 'المصاريف',
  paymentsAndExpenses: 'موردين + مصاريف',
  ariaOpenBalanceReport: 'فتح تقرير الرصيد',
  treasuryBalance: 'الرصيد الإجمالي',
  treasuryBalancePeriodHint: 'للفترة المحددة (وليس الميزانية الكاملة)',
  inOutMeta: 'السيولة حسب وسيلة الدفع',
  electronicTotal: 'إلكتروني',
  balanceStateTitle: 'حالة الأرصدة',
  balanceMethodColShort: 'الوسيلة',
  balanceInCol: 'وارد',
  balanceInColShort: 'وارد',
  balancePaymentsOutCol: 'مدفوعات الموردين',
  balancePaymentsOutColShort: 'الموردين',
  balanceExpensesOutCol: 'المصروفات',
  balanceExpensesOutColShort: 'المصروفات',
  balanceOutCol: 'صادر من الصندوق',
  balanceOutColShort: 'صادر',
  balanceSoldeCol: 'الرصيد',
  balanceSoldeColShort: 'الرصيد',
  balanceFinancingCol: 'تمويل خارجي',
  balanceFinancingColShort: 'خارجي',
  balanceOpeningCapitalCol: 'رأس مال البدء',
  balanceOpeningCapitalColShort: 'رأس المال',
  balanceFinancingHint:
    'رأس مال البدء ≠ التمويل الخارجي. لا يدخل أي منهما في الرصيد. الخارجي ليس مقتصراً على النقد.',
  noBalanceMethods: 'لا حركات في هذه الفترة',
  weeklySalesAria: 'مبيعات الأسبوع',
  revenueEvolution7Days: 'المبيعات (7 أيام)',
  todayRevenueTitle: 'مبيعات اليوم',
  urgentAlerts: 'تنبيه',
  ariaOpenEcarts: 'فتح فروق الصندوق',
  openEcarts: 'فروق الصندوق',
  ecartsChartAlert: '{{count}} فرق للمراجعة',
  urgentAlertTitleOne: 'فرق مكتشف',
  urgentAlertTitleMany: 'فروق مكتشفة',
  ecartsNeedReviewOne: 'يجب مراجعة فرق في الصندوق.',
  ecartsNeedReviewMany: '{{count}} فروق صندوق للمراجعة.',
  openEcartsSummary: 'تفاصيل فروق الصندوق',
  positive: 'زيادة',
  negative: 'نقص',
  ecartCount: 'حالة',
  total: 'المجموع',
  excess: 'زيادة',
  shortage: 'نقص',
  totalLabel: 'إجمالي',
  ecartTotalMeta: '{{type}} • {{count}} حالة',
  paymentMethods: 'الدفع',
  indicator: 'البند',
  amount: 'المبلغ',
  transactionsHeader: 'العدد',
  amountRow: 'المبلغ',
  countRow: 'العدد',
  periodCol: 'الفترة',
  moneyInCol: 'مبيعات',
  paymentsCol: 'موردين',
  expensesCol: 'مصاريف',
  balanceCol: 'الرصيد',
  noPaymentMethods: 'لا مدفوعات مسجلة',
  dailyWeeklyReports: 'ملخص الفترة',
  period: 'الفترة',
  moneyInTable: 'مبيعات',
  payments: 'موردين',
  expenses: 'مصاريف',
  balance: 'الرصيد',
  ariaOpenTodayReport: 'فتح تقرير اليوم',
  today: 'اليوم',
  ariaOpenWeekReport: 'فتح تقرير الأسبوع',
  sevenDays: 'أسبوع',
  financialSummaryTitle: 'ملخص مالي',
  moneyInCard: 'مبيعات',
  netFlow: 'الرصيد الإجمالي',
  inOutSubtitle: 'كل الوسائل — وارد − صادر الصندوق',
  paymentsExpensesCard: 'إجمالي المصروفات',
  paymentsExpensesSubtitle: 'موردين {{payments}} | مصاريف {{expenses}}',
  quickActions: 'إجراءات',
  keyboardHints: 'اختصارات: 1–7، R تقرير، E فروق الصندوق',
  quickActionsAria: 'إجراءات سريعة',
  backToDashboard: 'لوحة التحكم',
  backToDashboardAria: 'العودة إلى لوحة التحكم',
  familyEyebrow: 'من لوحة التحكم',
  shortcutN: 'اختصار {{n}}',
  shortcut3OrR: 'اختصار 3 أو R',
  shortcut5OrR: 'اختصار 5 أو R',
  scopePeriod: 'الفترة',
  scopeToday: 'اليوم',
  scopeCurrent: 'الحالي',
  scopeMixed: 'فترة · حالي',
  railMoneyGroup: 'المصروفات والالتزامات',
  railStockGroup: 'مخاطر المخزون',
  railStockOk: 'لا إشارة مخزون',
  showFinancingCols: 'رأس المال / خارجي',
  hideFinancingCols: 'إخفاء التفاصيل',
  sales: 'مبيعات',
  moneyOutAction: 'مصروفات',
  paymentReport: 'المدفوعات',
  ecarts: 'فروق الصندوق',
  inventory: 'المنتجات',
  reports: 'تقارير',
  sessions: 'الجلسات',
  ariaOpenSessions: 'فتح الجلسات في الإعدادات',
  dayClosing: 'إغلاق اليوم',
  ariaOpenDayClosing: 'فتح إغلاق اليوم في التقارير',
  lotMigration: 'ترحيل',
  needsImmediateReview: 'للمراجعة',
  kpiSalesFoot: '{{count}} عملية',
  kpiBalanceFoot: 'التفصيل حسب الوسيلة أدناه',
  kpiExternalFinancingFoot: 'تمويل خارجي: {{amount}}',
  externalFinancingSummary: 'تمويل خارجي (خارج الصندوق)',
  openingCapitalFinancingSummary: 'رأس مال البدء المستخدم',
  kpiAvgTicket: 'متوسط الفاتورة',
  kpiVsPrevious: 'مقارنة بالفترة السابقة',
  kpiUpdatedAt: 'تحديث {{time}}',
  kpiExpenses: 'المصاريف',
  kpiChangeFlat: '0 %',
  chartVsPreviousPeriod: 'مقارنة بالفترة السابقة',
  chartMetricRevenue: 'الإيرادات',
  chartMetricProfit: 'الهامش',
  chartMetricSales: 'المبيعات',
  chartMetricCustomers: 'العملاء',
  inventoryCardTitle: 'المنتجات',
  inventoryProducts: '{{count}} منتج',
  inventoryCritical: '{{count}} حرج',
  inventoryExpiring: '{{count}} ينتهي قريباً',
  inventoryEmptyLots: '{{count}} دفعات فارغة',
  inventoryActiveLots: '{{count}} دفعات نشطة',
  finOpenSupplierInvoices: 'فواتير موردين مفتوحة (نحن مدينون)',
  finInventoryValue: 'قيمة المخزون',
  finLowStock: 'مخزون منخفض',
  finOrderToday: 'اطلب اليوم',
  finExpiring: 'منتجات بتاريخ صلاحية',
  finActiveLots: 'دفعات نشطة',
  topActionSale: 'بيع',
  topActionPurchase: 'شراء',
  topActionProduct: 'منتج',
  topActionCustomer: 'عميل',
  topActionSupplier: 'مورد',
  topQuickActionsAria: 'إنشاء سريع',
  ariaOpenInventory: 'فتح المنتجات',
  loadingData: 'جاري تحميل البيانات…',
};
